export default function($) {
  var speed = 90; // ms

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });

  // Secondary nav

  var secondaryNav = $('.secondary-nav-items'),
  openSecondaryNav = $('.js-secondary-nav-trigger'),
  closeSecondaryNav = $('.js-secondary-nav-close');

  openSecondaryNav.on('click', function() {
    if( !secondaryNav.hasClass('open') ) {
      secondaryNav.addClass('open');
      openSecondaryNav.find('.secondary-nav-menu-icon').toggleClass('fill-grey-darker fill-primary');
    } else {
      secondaryNav.removeClass('open');
      openSecondaryNav.find('.secondary-nav-menu-icon').toggleClass('fill-grey-darker fill-primary');
    }
  });

  closeSecondaryNav.on('click', function() {
    if( secondaryNav.hasClass('open') ) {
      secondaryNav.removeClass('open');
      openSecondaryNav.find('.secondary-nav-menu-icon').toggleClass('fill-primary fill-grey-darker');
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.secondary-nav').length) {
      if (secondaryNav.hasClass("open")) {
        secondaryNav.removeClass('open');
        openSecondaryNav.find('.secondary-nav-menu-icon').toggleClass('fill-primary fill-grey-darker');
      }
    }
  });
}
